import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import BackgroundAnimation from './components/BackgroundAnimation'
import WaveIcon from './assets/wave-icon.svg'
import EeIcon from './assets/ee-icon.svg'
import WhatsappIcon from './assets/whatsapp-icon.svg'
import PixvulIcon from './assets/pixvul-icon.svg'
import SportsaiIcon from './assets/sportsai-icon.svg'
import PregoIcon from './assets/prego-icon.svg'

function App() {
  const { t, i18n } = useTranslation()
  const [currentLang, setCurrentLang] = useState(i18n.language || 'en')

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang)
    setCurrentLang(lang)
  }

  // Ensure state sync on mount
  useEffect(() => {
    setCurrentLang(i18n.language)
  }, [i18n.language])

  const links = [
    {
      icon: EeIcon,
      label: 'REFINA',
      url: 'https://refina.us'
    },
    {
      icon: PixvulIcon,
      label: 'pixvul',
      url: 'https://pixvul.com'
    },
    {
      icon: SportsaiIcon,
      label: 'SportsAI',
      url: 'https://futebol.ondata.click'
    },
    {
      icon: PregoIcon,
      label: 'Prego',
      url: 'https://get.pregoapp.com'
    },
    {
      icon: WhatsappIcon,
      label: 'WhatsApp',
      url: 'https://wa.me/5554994309699'
    }
  ]

  return (
    <>
      <BackgroundAnimation />

      <div className="overlay">
        {/* Language Switcher using Glass style from index.css logic implied */}
        <div style={{
          position: 'absolute',
          top: '2rem',
          right: '2rem',
          zIndex: 50,
          display: 'flex',
          gap: '10px',
          pointerEvents: 'auto'
        }}>
          <button
            onClick={() => changeLanguage('en')}
            style={{
              background: currentLang?.startsWith('en') ? 'rgba(255,255,255,0.2)' : 'transparent',
              border: '1px solid rgba(255,255,255,0.2)',
              color: 'white',
              padding: '5px 15px',
              borderRadius: '20px',
              cursor: 'pointer',
              fontFamily: 'inherit',
              transition: 'all 0.3s'
            }}
          >
            EN
          </button>
          <button
            onClick={() => changeLanguage('pt-BR')}
            style={{
              background: currentLang?.startsWith('pt') ? 'rgba(255,255,255,0.2)' : 'transparent',
              border: '1px solid rgba(255,255,255,0.2)',
              color: 'white',
              padding: '5px 15px',
              borderRadius: '20px',
              cursor: 'pointer',
              fontFamily: 'inherit',
              transition: 'all 0.3s'
            }}
          >
            PT
          </button>
        </div>

        <div className="content-container">
          <img
            src={WaveIcon}
            alt="Ondata Logo"
            style={{
              width: '80px',
              height: '80px',
              filter: 'drop-shadow(0 0 10px rgba(56, 189, 248, 0.5))',
            }}
          />

          <h1 className="logo-text">
            on<span className="logo-highlight">data</span>
          </h1>

          <p className="subtitle">
            {t('subtitle')}
          </p>

          <div className="nav-buttons">
            {links.map((link, index) => (
              <a
                key={index}
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                className="nav-btn"
                title={link.label}
              >
                <img src={link.icon} alt={link.label} />
              </a>
            ))}
          </div>
        </div>
      </div>
    </>
  )
}

export default App